import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import { configureStore } from "@reduxjs/toolkit";

import { thunk } from "redux-thunk";
import authReducer from "./Auth/reducer";
import purchaseReducer from "./Purchase/reducer";
import salesReducer from "./Sales/reducer";
import loadReducer from "./Load/reducer";
import commonReducer from "./Common/reducer";
import bookingReducer from "./Booking/reducer";
import addressReducer from "./Address/reducer";
import ratequoteReducer from "./RateQuote/reducer";
import importRateQuoteReducer from "./ImportRateQuote/reducer";
import loaderReducer from "./Loader/reducer";
import airExportRateQuoteReducer from "./Export/Air/RateQuotes/reducer";

import vesselReducer from "./Masters/vessel/reducer";
import commodityReducer from "./Masters/commodity/reducer";
import clauseReducer from "./Masters/clause/reducer";
import countryClauseReducer from "./Masters/countryclause/reducer";
import chargesCodeReducer from "./ChargesCode/reducer";
import { toastReducer } from "./Toast/reducer";
import PortPlaceReducer from "./Masters/PortPlace/reducer";
import locationReducer from "./Masters/location/reducer";
import ImportbookingReducer from "./ImportBooking/reducer";
import BookinRquestReducer from "./BookingRequest/reducer";
import UsersReducer from "./Masters/users/reducer";
import CustomerReducer from "./Masters/customers/reducer";
import AllModulesReducer from "./Modules/reducer";
import MasterCompanyReducer from "./company/reducer";
import BaseModulesReducer from "./Modules/baseModules/reducer";
import modulesReducer from "./Modules/modules/reducers";
import subModulesReducer from "./Modules/subModules/reducers";
import fclExportReportsReducer from "./FCLExportReports/reducer";
import fclImportReportsReducer from "./FCLImportReports/reducer";
import baseNavigationsReducer from "./features/baseNavigation/baseNavigationSlice";
import navigationsReducer from "./features/navigation/navigationSlice";
import subNavigationsReducer from "./features/subNavigation/subNavigationSlice";
import accountTypeReducer from "./features/accountType/accountTypeSlice";
import navigationVisibilityReducer from "./features/navigationVisibility/navigationVisibilitySlice";
import domesticExportRateQuoteReducer from "./Export/Domestic/RateQotes/reducer";
import sidebarNavigatinReducer from "./features/sidebarNavigation/sidebarNavigationSlice";
import companyReducer from "./features/company/companySlice";
import rolesReducer from "./features/roles/rolesSlice";
import rolePermissionReducer from "./features/rolePermission/rolePermissionSlice";
import { applicableChargesApi } from "./features/applicableCharges/applicableChargesApi";
import { officeTypeApi } from "./features/officeType/officeTypeApi";
import { terminalMappingApi } from "./features/terminalMapping/terminalMappingApi";
import { dashboardApi } from "./features/adminDashboard/dashboardApi";
import { companyApi } from "./features/company/companyApi";
import { inttraApi } from "./features/inttra/inttraApi";
import { companyNavigationApi } from "./features/companyNavigations/companyNavigationApi";
import { sidebarNavigationApi } from "./features/sidebarSequence/sidebarNavigationApi";

const getLocalStorageItem = (key) => {
    try {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    } catch {
        return null;
    }
};

const preloadedState = {
    auth: {
        userDetails: getLocalStorageItem("authUser"),
        userToken: localStorage.getItem("authToken") || null,
        isLoading: false,
        currentLocation: "",
    },
};

const rootReducer = combineReducers({
    auth: authReducer,
    purchase: purchaseReducer,
    sales: salesReducer,
    load: loadReducer,
    common: commonReducer,
    booking: bookingReducer,
    addressBook: addressReducer,
    rateQuote: ratequoteReducer,
    loader: loaderReducer,
    vessel: vesselReducer,
    commodity: commodityReducer,
    clause: clauseReducer,
    countryClause: countryClauseReducer,
    chargesCode: chargesCodeReducer,
    PortPlace: PortPlaceReducer,
    toast: toastReducer,
    locations: locationReducer,
    importRateQuoteReducer: importRateQuoteReducer,
    importBooking: ImportbookingReducer,
    bookinRquest: BookinRquestReducer,
    users: UsersReducer,
    customers: CustomerReducer,
    allModules: AllModulesReducer,
    baseModules: BaseModulesReducer,
    modules: modulesReducer,
    subModules: subModulesReducer,
    masterCompany: MasterCompanyReducer,
    fclExportReports: fclExportReportsReducer,
    fclImportReports: fclImportReportsReducer,
    baseNavigations: baseNavigationsReducer,
    navigations: navigationsReducer,
    subNavigations: subNavigationsReducer,
    accountType: accountTypeReducer,
    navigationVisibility: navigationVisibilityReducer,
    rolePermissions: rolePermissionReducer,
    sidebarNavigation: sidebarNavigatinReducer,
    company: companyReducer,
    roles: rolesReducer,
    [applicableChargesApi.reducerPath]: applicableChargesApi.reducer,
    [officeTypeApi.reducerPath]: officeTypeApi.reducer,
    [terminalMappingApi.reducerPath]: terminalMappingApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [inttraApi.reducerPath]: inttraApi.reducer,
    [companyNavigationApi.reducerPath]: companyNavigationApi.reducer,
    [sidebarNavigationApi.reducerPath]: sidebarNavigationApi.reducer,
});

// const composeEnhancers =
//     window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// const store = createStore(
//     rootReducer,
//     preloadedState,
//     composeEnhancers(
//         applyMiddleware(thunk)
//     )
// );

const store = configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            applicableChargesApi.middleware,
            officeTypeApi.middleware,
            terminalMappingApi.middleware,
            dashboardApi.middleware,
            companyApi.middleware,
            inttraApi.middleware,
            companyNavigationApi.middleware,
            sidebarNavigationApi.middleware,
        ),
    devTools: process.env.NODE_ENV !== "production",
});

// store.subscribe(() => {
//     console.log('Current store state:', store.getState());
// });

export default store;
